import React, { useContext } from 'react';
import styles from './styles.module.css';
import { CartContext } from '../../../contexts/CartContext';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../const';
import { ShopContext } from '../../../contexts/ShopContext';

function CartViewBar() {
  const history = useHistory();
  const { shop } = useContext(ShopContext);
  const shopId = shop?.shopId;
  const { itemsCount } = useContext(CartContext);

  const handleMoveToCart = () => {
    history.push(ROUTES.CART.replace(':shopId', shopId));
  };

  return (
    <div className={styles.container}>
      <span>{itemsCount} Item added</span>
      <span style={{ cursor: 'pointer' }} onClick={handleMoveToCart}>
        View cart
      </span>
    </div>
  );
}

export default CartViewBar;
